export default __webpack_public_path__ + "static/media/patients.e05df3b3.svg";